var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css, cx } from "@emotion/css";
var Description = function (_a) {
    var description = _a.description;
    return (_jsx("div", __assign({ className: cx("tag", css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          display: none;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          padding: 6px;\n          white-space: nowrap;\n          font-size: 20px;\n          background-color: #000;\n          border-radius: 9px;\n          transform: translate(-50%, -50px);\n          color: #fff;\n          text-align: center;\n        "], ["\n          display: none;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          padding: 6px;\n          white-space: nowrap;\n          font-size: 20px;\n          background-color: #000;\n          border-radius: 9px;\n          transform: translate(-50%, -50px);\n          color: #fff;\n          text-align: center;\n        "])))) }, { children: description })));
};
export default Description;
var templateObject_1;
